// extracted by mini-css-extract-plugin
module.exports = {"panel":"style_panel__rP9CL","icon":"style_icon__3o72B","body":"style_body__3_uEL","cta":"style_cta__1WjBx","alt":"style_alt__1mAGi"};